import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Location Map Data
export const fetchLocationMap = createAsyncThunk(
  "locationMap/fetchLocationMap",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/location/panel/LocationMap");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Location to the Map
export const addLocationMap = createAsyncThunk(
  "locationMap/addLocationMap",
  async (newLocationData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/LocationMap", newLocationData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Location Map Data
export const updateLocationMap = createAsyncThunk(
  "locationMap/updateLocationMap",
  async (locationData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/LocationMap", locationData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Location Map Slice
const locationMapSlice = createSlice({
  name: "locationMap",
  initialState: {
    locationMapList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Location Map Data
      .addCase(fetchLocationMap.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchLocationMap.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.locationMapList = action.payload;
      })
      .addCase(fetchLocationMap.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Location to Map
      .addCase(addLocationMap.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addLocationMap.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addLocationMap.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Location Map
      .addCase(updateLocationMap.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateLocationMap.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateLocationMap.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = locationMapSlice.actions;

export default locationMapSlice.reducer;
